import React, { useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import ColorPickerBasic from './ColorPickerBasic'

const ColorPicker = (props: any) => {
    const { selectedColor, setSelectedColor, type } = props

    const colors = [
        { id: 'pink', color: '#DC4981' },
        { id: 'red', color: '#EA3B3E' },
        { id: 'orange', color: '#F8961E' },
        { id: 'yellow', color: '#F7C550' },
        { id: 'green', color: '#94CD68' },
        { id: 'turquoise', color: '#52B8AC' },
        { id: 'light-blue', color: '#5A91BD' },
        { id: 'blue', color: '#5247D1' },
        { id: 'purple', color: '#A03AD7' },
    ]

    // useEffect(() => {
    //     setSelectedColor(colors[0].color)
    // }, [])

    return type && type === 'basic' ? (
        <ColorPickerBasic />
    ) : (
        <div className="d-flex justify-content-between mt-2">
            {colors.map((c, i) => (
                <Button
                    key={i}
                    className="p-button-rounded border-0"
                    style={{
                        backgroundColor: c.color,
                        height: '32px',
                        width: '32px',
                    }}
                    icon={
                        selectedColor && c.color === selectedColor.toUpperCase()
                            ? 'pi pi-circle-on'
                            : ''
                    }
                    onClick={() => setSelectedColor(c.color)}
                />
            ))}
        </div>
    )
}

export default ColorPicker
